import React, { Component } from 'react';
import SimpleReactValidator from 'simple-react-validator';
import LaddaButton, { EXPAND_RIGHT } from 'react-ladda';
import { alertSelectors } from '../../../common/redux/selectors';
import { itemService, globalService as gs } from '../../../common/services';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import { confirmAlert } from 'react-confirm-alert';
import { authActions } from '../../../common/redux/actions';

class DeactivateAccountForm extends Component {
    constructor(props) {

        super(props);
        this.state = {
            formField: {
                password: '',
                token: gs.authToken()
            },
            submitted: false,
            loading: false,
        };
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            className: 'valid-feedback d-block text-danger',
        });
    }

    handleChange = (e) => {
        let formField = {...this.state.formField};
        formField[e.target.name] = e.target.value;
        this.setState({formField});
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const { formField } = this.state;
        if( this.validator.allValid() ) {
            confirmAlert({
                title: `Please confirm to remove`,
                buttons: [
                    {
                        label: 'No',
                        onClick: () => console.log('No')
                    },
                    {
                        label: 'Yes',
                        onClick: () => {
                            this.setState({loading: true});
                            const { dispatch } = this.props;
                            itemService.deactivateAccount("DELETE", formField).then(data => {
                                dispatch(alertSelectors.success('You have successfully deactivate your account.'));
                                dispatch(authActions.logout());
                            })
                            .catch(exception => {
                                gs.showErrors(dispatch, exception, alertSelectors);
                                this.setState({loading: false});
                            });
                        }
                    }
                ]
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }        
    };

    render() {
        this.validator.purgeFields();
        const { formField, loading } = this.state;
        //console.log('gs.authToken', gs.authToken());
        return (
            <div>
                <div className="mb-3"><b>Note:</b> Deactivating your account will disable your Profile and remove your name and photos.</div>
                <form name="form" onSubmit={this.handleSubmit} noValidate>
                    <div className="form-group">
                        <label>Your Password</label>
                        <input type="password" className="form-control" name="password" value={formField.password} onChange={this.handleChange} />
                        {this.validator.message('password', formField.password, 'required')}
                    </div>
                    <div className="form-group">
                        <LaddaButton className="btn btn-primary" loading={loading} data-style={EXPAND_RIGHT}>Deactivate Account</LaddaButton>
                    </div>
                </form>
                {/* <LaddaButton className="btn btn-primary" type="button" onClick={this.handleSubmit} loading={loading} data-style={EXPAND_RIGHT}>Deactivate Account</LaddaButton> */}
            </div>
        );
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);

const mapStateToProps = createSelector(
    processSelector,
    (process) => ({
        process
    })
);

export default connect(mapStateToProps)(DeactivateAccountForm);